module.exports = __webpack_public_path__ + "static/redime-tus-puntos-2-AR-ee0350da28449440b2ddcfb9051d549f.png";